import React from 'react';
import './NewsletterPopup.css';

export const NewsletterSignupContent = ({
  titleId = 'newsletter-popup-title',
  title = 'Tu celebración empieza aquí',
  description = 'Estamos preparando una colección de estampitas delicadas para bautismo y primera comunión.',
  benefitsIntro = 'Suscribite y recibí antes que nadie:',
  benefits = ['Acceso anticipado', 'Nuevos diseños', 'Beneficios de lanzamiento'],
  showBenefits = true,
  buttonLabel = 'QUIERO ENTERARME',
  loadingLabel = 'ENVIANDO...',
  bottomText = 'Te escribiremos solo cuando tengamos algo lindo que mostrarte.',
  firstName,
  setFirstName,
  email,
  setEmail,
  status,
  error,
  handleSubmit,
}) => (
  <div className="newsletter-popup__content">
    <h1 id={titleId}>{title}</h1>
    <p>{description}</p>
    {showBenefits && (
      <>
        <p className="newsletter-popup__textbenefits">{benefitsIntro}</p>
        <ul className="newsletter-popup__benefits">
          {benefits.map((benefit) => (
            <li key={benefit}>{benefit}</li>
          ))}
        </ul>
      </>
    )}

    <form onSubmit={handleSubmit} className="newsletter-popup__form">
      <input
        type="text"
        placeholder="Tu Nombre"
        value={firstName}
        onChange={(event) => setFirstName(event.target.value)}
        required
        disabled={status === 'loading'}
      />
      <input
        type="email"
        placeholder="Tu Email"
        value={email}
        onChange={(event) => setEmail(event.target.value)}
        required
        disabled={status === 'loading'}
      />
      <button type="submit" disabled={status === 'loading'}>
        {status === 'loading' ? loadingLabel : buttonLabel}
      </button>
    </form>

    {error && <p className="newsletter-popup__error">{error}</p>}
    {status === 'success' && <p className="newsletter-popup__success">¡Listo! Ya estás suscripto/a.</p>}
    {bottomText && <p className="newsletter-popup__bottomtext">{bottomText}</p>}
  </div>
);
